// extracted by mini-css-extract-plugin
module.exports = {"container":"StrHeader_container__RFayf","button":"StrHeader_button__JIWqo","text":"StrHeader_text__13Zvt"};